/*******************************************************************************
* Simple Bundles & Kits option picker restyle
*
* Enhances the app block's own markup (#simple-bundles-io-options) in place:
* adds a title, shortens option labels, swaps single-option items for an
* "Included" line, and locks fully sold-out items with a "Sold out" badge.
* While any item is sold out, Add to cart and Buy Now read "Sold out" and do
* nothing, and the stock line reads "Out of stock". The price at the top
* follows the chosen options: the bundle's price plus each option's
* "(+$x)" price difference. The app's <select>s stay the real form fields
* (name="properties[...]", required) and are never replaced, so the app's
* change listeners and cart properties keep working.
* Styles live in simple-bundles-options.css.
*******************************************************************************/
(function () {
  var ROOT_ID = 'simple-bundles-io-options';
  var TITLE = 'Build your package';
  var SOLD_OUT_FALLBACK = 'Sold out';
  var OUT_OF_STOCK_FALLBACK = 'Out of stock';
  // Font Awesome "xmark", the icon the theme's stock line uses for out of stock.
  var X_ICON = '<svg class="icon" data-sb-icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" aria-hidden="true" focusable="false"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';
  var CHECK_ICON = '<svg class="sb-options__icon" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M5.5 10.5l3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function formatMoney(amount) {
    var sb = window.SimpleBundles;
    // Same conversion the app uses for its own "(+$x)" suffix.
    var rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    if (rate && rate !== 1) amount *= rate;
    if (sb && sb.currencyFormatter && sb.currencyFormatter.format) return sb.currencyFormatter.format(amount);
    return '$' + amount.toFixed(2);
  }

  function isSoldOut(option) {
    return option.disabled || (parseFloat(option.getAttribute('data-inventory')) || 0) <= 0;
  }

  // Option values look like "<Product> - <variant>". Strip the product name,
  // or, when one select mixes product families, keep a short family label.
  function splitValue(value, itemName) {
    var prefix = itemName + ' - ';
    if (value.indexOf(prefix) === 0) return { family: itemName, short: value.slice(prefix.length) };
    var dash = value.lastIndexOf(' - ');
    if (dash < 1) return { family: '', short: value };
    return { family: value.slice(0, dash), short: value.slice(dash + 3) };
  }

  function shortFamily(family, itemName) {
    var short = family;
    if (itemName && short.toLowerCase().endsWith(' ' + itemName.toLowerCase())) short = short.slice(0, -itemName.length - 1);
    return short.replace(/\s+Series$/i, '');
  }

  function optionText(option, parts, mixed, itemName, allSoldOut) {
    var text = (mixed && parts.family ? shortFamily(parts.family, itemName) + ' ' : '') + parts.short;
    var diff = parseFloat(option.getAttribute('data-price-diff')) || 0;
    if (diff) text += ' (' + (diff > 0 ? '+' : '-') + formatMoney(Math.abs(diff)) + ')';
    if (isSoldOut(option) && !allSoldOut) text += ' — sold out';
    return text;
  }

  function setStatus(select, kind, html) {
    var status = select.nextElementSibling;
    if (!status || !status.classList.contains('sb-options__status')) {
      status = document.createElement('div');
      select.insertAdjacentElement('afterend', status);
    }
    status.className = 'sb-options__status sb-options__status--' + kind;
    status.innerHTML = html;
  }

  function productString(key, fallback) {
    var strings = (window.theme && (theme.productStrings || theme.strings)) || {};
    return strings[key] || fallback;
  }

  function soldOutText() {
    return productString('soldOut', SOLD_OUT_FALLBACK);
  }

  function setBadge(label, show) {
    if (!label) return;
    label.classList.toggle('sb-options__label--sold-out', show);
    var badge = label.querySelector('.sb-options__badge');
    if (show && !badge) {
      badge = document.createElement('span');
      badge.className = 'sb-options__badge';
      badge.textContent = soldOutText();
      label.appendChild(badge);
    } else if (!show && badge) {
      badge.remove();
    }
  }

  function enhanceItem(root, select) {
    var label = root.querySelector('label[for="' + CSS.escape(select.id) + '"]');
    // Read the name once, before the badge is added to the label.
    if (label && !label.hasAttribute('data-sb-name')) label.setAttribute('data-sb-name', label.textContent.trim());
    var itemName = label ? label.getAttribute('data-sb-name') : '';
    var options = Array.prototype.filter.call(select.options, function (o) {
      return o.value !== '';
    });
    if (!options.length) return;

    var split = options.map(function (o) {
      return splitValue(o.value, itemName);
    });
    var families = {};
    split.forEach(function (p) {
      families[p.family] = true;
    });
    var mixed = Object.keys(families).length > 1;
    var allSoldOut = options.every(isSoldOut);

    options.forEach(function (o, i) {
      o.textContent = optionText(o, split[i], mixed, itemName, allSoldOut);
      // Stops the app appending its own price suffix if it runs after us.
      o.setAttribute('data-price-displayed', 'true');
    });

    select.classList.remove('sb-options__select--hidden', 'sb-options__select--sold-out');
    select.removeAttribute('tabindex');
    if (select.hasAttribute('data-sb-locked')) {
      select.removeAttribute('data-sb-locked');
      select.disabled = false;
    }
    setBadge(label, allSoldOut);

    if (allSoldOut) {
      // Show the piece greyed out and locked. The form can't be submitted
      // while it is sold out (see syncSoldOut), so disabling it is safe.
      var stale = select.nextElementSibling;
      if (stale && stale.classList.contains('sb-options__status')) stale.remove();
      select.classList.add('sb-options__select--sold-out');
      select.setAttribute('data-sb-locked', 'true');
      select.disabled = true;
      select.value = options[0].value;
    } else if (options.length === 1) {
      select.classList.add('sb-options__select--hidden');
      select.setAttribute('tabindex', '-1');
      setStatus(select, 'included', CHECK_ICON + '<span>Included</span>');
      if (select.value !== options[0].value) {
        select.value = options[0].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      var status = select.nextElementSibling;
      if (status && status.classList.contains('sb-options__status')) status.remove();
    }
  }

  function enhance(root) {
    if (root.getAttribute('data-sb-enhanced') === 'true') return;
    root.setAttribute('data-sb-enhanced', 'true');
    root.classList.add('sb-options');

    if (!root.querySelector('.sb-options__title')) {
      var title = document.createElement('h3');
      title.className = 'sb-options__title';
      title.textContent = TITLE;
      root.insertBefore(title, root.firstChild);
    }

    root.querySelectorAll('select').forEach(function (select) {
      enhanceItem(root, select);
    });
  }

  function bundleSoldOut(root) {
    return !!root.querySelector('select[data-sb-locked]');
  }

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  // Inventory is fixed once the page loads, so this only ever switches the
  // buttons and stock line to sold out. The theme and custom.js rewrite both
  // on load and on variant changes, so this runs on every DOM change and only
  // writes when something differs.
  function syncSoldOut(root) {
    if (!bundleSoldOut(root)) return;
    var scope = root.closest('.product-single__meta') || document;
    var text = soldOutText();
    var addToCart = scope.querySelector('[data-add-to-cart]');
    var buyNow = scope.querySelector('.buy-with-now');

    if (addToCart) {
      if (!addToCart.classList.contains('sb-cart-btn--sold-out')) addToCart.classList.add('sb-cart-btn--sold-out');
      if (addToCart.getAttribute('aria-disabled') !== 'true') addToCart.setAttribute('aria-disabled', 'true');
      if (addToCart.getAttribute('aria-label') !== text) addToCart.setAttribute('aria-label', text);
      setText(addToCart.querySelector('[data-add-to-cart-text]'), text);
    }
    if (buyNow) {
      if (!buyNow.classList.contains('sb-cart-btn--sold-out')) buyNow.classList.add('sb-cart-btn--sold-out');
      if (buyNow.getAttribute('aria-disabled') !== 'true') buyNow.setAttribute('aria-disabled', 'true');
      setText(buyNow.querySelector('span') || buyNow, text);
    }

    var stock = scope.querySelector('.product-form__inventory');
    if (stock) {
      if (!stock.classList.contains('sb-inventory--sold-out')) stock.classList.add('sb-inventory--sold-out');
      var status = stock.querySelector('.product-form__inventory-icon-status');
      if (status && !status.classList.contains('text-danger')) {
        status.classList.remove('text-success', 'text-warning');
        status.classList.add('text-danger');
      }
      var icon = status && status.querySelector('load-icon');
      if (icon && !icon.querySelector('[data-sb-icon]')) {
        icon.setAttribute('name', 'x');
        icon.innerHTML = X_ICON;
      }
      setText(stock.querySelector('.product-form__inventory-text'), productString('outOfStock', OUT_OF_STOCK_FALLBACK));
    }
  }

  // Capture phase runs before the theme's submit handler, the Buy Now
  // inline onclick and its jQuery handler, so none of them fire.
  function blockWhenSoldOut(event) {
    var root = document.getElementById(ROOT_ID);
    if (!root || !bundleSoldOut(root)) return;
    var target = event.target;
    var hit = event.type === 'submit'
      ? target.matches && target.matches('[data-product-form]') && target.contains(root)
      : target.closest && target.closest('.buy-with-now, [data-add-to-cart]');
    if (!hit) return;
    event.preventDefault();
    event.stopPropagation();
  }
  document.addEventListener('submit', blockWhenSoldOut, true);
  document.addEventListener('click', blockWhenSoldOut, true);

  // The bundle variant's own price (cents, presentment currency) from the
  // section's ProductJson, read once.
  function bundleVariant(root) {
    if (root._sbVariant !== undefined) return root._sbVariant;
    root._sbVariant = null;
    var section = root.closest('[data-section-id]');
    var json = section && document.getElementById('ProductJson-' + section.getAttribute('data-section-id'));
    if (!json) return null;
    var id = Number(root.getAttribute('data-simple-bundles-variant-id'));
    var variants = JSON.parse(json.textContent).variants || [];
    root._sbVariant = variants.filter(function (v) {
      return v.id === id;
    })[0] || variants[0] || null;
    return root._sbVariant;
  }

  function selectedDiffCents(root) {
    var rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    var total = 0;
    root.querySelectorAll('select').forEach(function (select) {
      var option = select.options[select.selectedIndex];
      if (option) total += parseFloat(option.getAttribute('data-price-diff')) || 0;
    });
    return Math.round(total * (rate || 1) * 100);
  }

  function setMoney(el, cents) {
    if (!el || !window.theme || !theme.Currency) return;
    setText(el, theme.Currency.formatMoney(cents, theme.moneyFormat));
  }

  // Runs on every DOM change, so it also wins over the theme's own price
  // update and only writes when the shown price differs.
  function syncPrice(root) {
    var variant = bundleVariant(root);
    var scope = root.closest('.product-single__meta');
    var price = scope && scope.querySelector('[data-price]');
    if (!variant || !price) return;
    var diff = selectedDiffCents(root);
    var onSale = variant.compare_at_price > variant.price;
    // Shifting the compare-at price by the same amount keeps the savings the same.
    price.querySelectorAll('[data-regular-price]').forEach(function (el) {
      setMoney(el, (onSale ? variant.compare_at_price : variant.price) + diff);
    });
    if (onSale) setMoney(price.querySelector('[data-sale-price]'), variant.price + diff);
  }

  function check() {
    var root = document.getElementById(ROOT_ID);
    // The app renders this block empty on products that aren't bundles.
    if (!root || !root.querySelector('select')) return;
    enhance(root);
    syncSoldOut(root);
    syncPrice(root);
  }

  // Selects firing change don't touch the DOM, so the observer can't see them.
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('#' + ROOT_ID)) check();
  });

  // The app block can render (or be re-rendered) after this script runs.
  check();
  new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
})();
